import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { HashRouter } from 'react-router-dom';
import { AuthenticationProvider } from './components/authentication/AuthenticationContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <AuthenticationProvider>
    <HashRouter>
      <App />
    </HashRouter>
  </AuthenticationProvider>
);
